const en = {
  // Page
  pageTitle: 'Vibe Suite \u2014 AI Skill Guide',
  pageSubtitle: 'Your path from first prompt to shipped product',
  firstTimeClick: 'First time? Click here',
  searchPlaceholder: 'Search skills...',
  showLabel: 'Show',
  filterAll: 'All',
  filterLearned: 'Learned',
  filterNotLearned: 'Not Learned',

  // Guide modal
  guideAccent: 'How this works',
  guideTitle: 'Your AI does the teaching. This map tells it what.',
  guideStep1Title: 'Pick a skill',
  guideStep1Desc:
    "Each card is a real project. Click one to see what you'll build and get a ready-made instruction for your AI.",
  guideStep2Title: 'Give it to your AI',
  guideStep2Desc:
    'Copy the instruction and paste it into Claude, ChatGPT, or Cursor. Build the project together, step by step.',
  guideStep3Title: 'Mark as learned',
  guideStep3Desc:
    'Done building? Mark it. Your progress bar and recommendations update automatically.',
  guideGotIt: 'Got it',

  // Why modal
  whyP1:
    'Most knowledge workers are becoming irrelevant. Not next year. Right now. Every single day.',
  whyP2:
    'This isn\u2019t doom-scrolling anxiety\u00A0\u2014 it\u2019s math. AI replaces tasks, tasks make up jobs, jobs disappear quietly while people argue on Twitter about whether it\u2019s \u201Creally\u201D happening.',
  whyP3:
    'This skill map is your chance to stay relevant. Learn to build with AI\u00A0\u2014 not compete against it\u00A0\u2014 so that in your 30s and 40s you still get to choose what you do for a living.',

  // ProgressHeader
  milestoneObserver: 'Observer',
  milestoneExplorer: 'Explorer',
  milestoneMaster: 'Master',
  milestoneSingularity: 'Singularity',
  reached: 'Reached!',
  skillSingular: 'skill',
  skillPlural: 'skills',
  toMilestone: 'to',
  myProgress: 'My Progress',
  progressBody1:
    'Copy your learning state and paste it into any AI assistant you use for building.',
  progressBody2:
    "Tell it what you want to build \u2014 it will see which skills you already have and which ones you haven't touched yet, then suggest an approach that plays to your strengths while filling in the gaps. Just paste and go.",
  copyStateLine1:
    'Here is my current skill profile. Each skill is marked as LEARNED or NOT LEARNED.',
  copyStateLine2: 'When I describe what I want to build, use this profile to:',
  copyStateLine3:
    '1. Suggest an architecture and tech stack that leverages skills I already know.',
  copyStateLine4:
    "2. Identify which skills I haven't learned yet that would be valuable for the project, and offer to teach them as we go.",
  copyStateLine5:
    '3. Give me options \u2014 one path that stays inside my comfort zone, one that stretches it, and one that balances both.',
  progressPrefix: 'Progress:',
  skillsWord: 'skills',
  learned: 'LEARNED',
  notLearned: 'NOT LEARNED',
  copyStateEnd: "Now, here's what I want to build:",
  copied: 'Copied',
  copyMyLearningState: 'Copy my learning state',
  close: 'Close',
  toTheGlory: 'T O   T H E   G L O R Y',

  // CategoryNav
  categoriesTitle: 'Categories',
  whatToLearnNext: 'What to learn next?',
  personalizedForYou: 'Personalized for you',
  allCategories: 'All Categories',
  whyDoINeedThis: 'Why do I need this?',

  // SkillDetailPanel
  difficultyBeginner: 'Beginner',
  difficultyIntermediate: 'Intermediate',
  difficultyAdvanced: 'Advanced',
  whatYoullBuild: "What you'll build",
  tools: 'Tools',
  prerequisites: 'Prerequisites',
  howToLearnThis: 'How to learn this',
  hideGuide: 'Hide guide',
  firstTimeReadThis: 'First time? Read this',
  detailGuideHeading: 'Each skill is a real project you build with AI:',
  detailGuideStep1Bold: 'Copy the instruction',
  detailGuideStep1Rest:
    'below and paste it into your AI assistant (Claude, ChatGPT, Cursor, etc.)',
  detailGuideStep2Bold: 'Follow along',
  detailGuideStep2Rest:
    'as the AI walks you through building it step by step in your own project',
  detailGuideStep3Bold: 'Mark as learned',
  detailGuideStep3Rest:
    "once you've completed it. No quizzes, no grades \u2014 you built it, you learned it.",
  detailGuideTip:
    "That's it. No videos. No courses. You learn by building real things.",
  copiedExcl: 'Copied!',
  copyInstruction: 'Copy Instruction',
  unmarkAsLearned: 'Unmark as Learned',
  markAsLearned: 'Mark as Learned',

  // Knowledge Gaps
  knowledgeGaps: 'Your Knowledge Gaps',
  knowledgeGapsTitle: 'AI SaaS Platform — Full Build Path',
  knowledgeGapsSubtitle:
    'Your knowledge mapped across a real project lifecycle',
  stageTooling: 'Tooling Setup',
  stagePrototype: 'Prototype',
  stageBackend: 'Backend Foundation',
  stageAiCore: 'AI Core',
  stageFrontendPolish: 'Frontend Polish',
  stageInfrastructure: 'Infrastructure',
  stageMonetization: 'Monetization & Growth',
  stageIntegrations: 'Integrations',
  stageSecurity: 'Security Hardening',
  stageScale: 'Scale & Optimize',

  // RecommendationModal
  whatToLearnNextTitle: 'What to learn next',

  // Recommendation reasons
  reasonUnlocks: 'Unlocks',
  reasonNewSkill: 'new skill',
  reasonNewSkills: 'new skills',
  reasonQuickWin: 'Quick win',
  reasonMatchesLevel: 'Matches your current level',
  reasonAllPrereqsDone: 'All prerequisites done',
  reasonGoodNextStep: 'Good next step',
};

export default en;
